import { FC } from 'react';

import { useCardOfferDataContext } from 'shared/context/CardContext';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';

import { CardDescription } from './CardDescription';

type CardDescriptionContainerProps = {
  isCardWithAmenities: boolean;
};

export const CardDescriptionContainer: FC<CardDescriptionContainerProps> = props => {
  const { isCardWithAmenities } = props;
  const {
    description,
    extendedProperties: { offerServices },
  } = useCardOfferDataContext();
  const isShortListing = useListingLayoutIsShortSelector();

  const rowsAmount = ((): 2 | 4 => {
    if (offerServices?.isTop3 && !isCardWithAmenities && !isShortListing) {
      return 4;
    }

    return 2;
  })();

  return <CardDescription description={description} rowsAmount={rowsAmount} />;
};
